/**
 * Auth bootstrap: take TG initData, post to /auth/tg-mini-app/, hydrate user.
 * Re-runs `fetchMe()` on mount if we already have a token.
 */

import { useEffect } from 'react';
import { useAuthStore } from '@/store';
import { useTgInitData } from './useTgUser';
import { ApiError } from '@/api';
import * as authApi from '@/api/auth';
import { tokenStore } from '@/api/client';
import { logger } from '@/utils/logger';

export function useAuthBootstrap(): void {
  const initData = useTgInitData();
  const setUser = useAuthStore((s) => s.setUser);
  const setLoading = useAuthStore((s) => s.setLoading);
  const setError = useAuthStore((s) => s.setError);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const hasToken = tokenStore.getAccess();
        if (hasToken) {
          try {
            const user = await authApi.fetchMe();
            if (!cancelled) setUser(user);
            return;
          } catch (err) {
            if (err instanceof ApiError && err.status !== 401) {
              throw err;
            }
            // fall through to re-login
          }
        }
        if (!initData) {
          if (!cancelled) setError('Mini App має бути відкрито через Telegram');
          return;
        }
        const result = await authApi.loginWithTgInitData(initData);
        if (!cancelled) setUser(result.user);
      } catch (err) {
        logger.error('Auth bootstrap failed', err);
        const message = err instanceof Error ? err.message : 'Не вдалось увійти';
        if (!cancelled) setError(message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [initData, setUser, setLoading, setError]);
}
